import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ImPropTypes from 'react-immutable-proptypes';
import Im from 'immutable';
import copy from 'copy-to-clipboard';
import { useLocation } from 'react-router';
// import { escapeDeepLinkPath } from '../../utils/swagger/utils';
import { showSuccess } from '../../../elements/Toasts/toastActions';
import { ReactComponent as CopyIcon } from '../../../styles/icon/copy.svg';
import strings from '../../../lang/lang';

import operation from './OperationTag.module.scss';

const OperationTag = ({ tagObj, tag, children, layoutSelectors, layoutActions, getConfigs }) => {
  const location = useLocation();
  const tagRep = tag.replaceAll(' ', '%20');

  const handleCopy = () => {
    const path = `${window.location.origin}${location.pathname}#/${tagRep}`;

    copy(path);
    showSuccess(strings.appWebhookDetails.text.copied);
  };

  let { docExpansion } = getConfigs();

  let tagDescription = tagObj.getIn(['tagDetails', 'description'], null);

  let isShownKey = ['operations-tag', tag];
  let showTag = layoutSelectors.isShown(
    isShownKey,
    docExpansion === 'full' || docExpansion === 'list'
  );

  useEffect(() => {
    if (location.hash == `#/${tagRep}`) {
      const el = document.getElementById(`${tagRep}`);

      if (el) {
        window.scrollTo({
          top: el.offsetTop + 10,
          behavior: 'smooth',
        });
      }
    }
  }, []);

  return (
    <div
      className={showTag ? 'opblock-tag-section is-open' : 'opblock-tag-section'}
      data-guide={tag}
    >
      <div className={operation.operation__title}>
        <h3
          onClick={() => layoutActions.show(isShownKey, true)}
          className={!tagDescription ? 'opblock-tag no-desc' : 'opblock-tag'}
          id={tag.replaceAll(' ', '%20')}
          // id={isShownKey.map((v) => escapeDeepLinkPath(v)).join('-')}
          // data-is-open={showTag}
        >
          {tag.replaceAll('-', ' ')}
        </h3>
        <div onClick={handleCopy} className={operation.operation__wrapper}>
          <CopyIcon className={operation.operation__icon} />
        </div>
      </div>

      {children}
    </div>
  );
};

OperationTag.propTypes = {
  tagObj: ImPropTypes.map.isRequired,
  tag: PropTypes.string.isRequired,
  layoutSelectors: PropTypes.object.isRequired,
  layoutActions: PropTypes.object.isRequired,
  getConfigs: PropTypes.func.isRequired,
  getComponent: PropTypes.func.isRequired,
  specUrl: PropTypes.string.isRequired,
  children: PropTypes.element,
};

OperationTag.defaultProps = {
  tagObj: Im.fromJS({}),
  tag: '',
};

export default OperationTag;
